/* IMPORT */
import { OWNER } from './superroot.js';
import { lazySetAdd, lazySetDelete } from '../lazy.js';
import Owner from './owner.js';
import { SYMBOL_SUSPENSE } from '../symbols.js';
import { Stack } from '../methods/debugger.js';
/* MAIN */
class Root extends Owner {
    /* CONSTRUCTOR */
    constructor(register) {
        super();
        /* VARIABLES */
        this.parent = OWNER;
        this.context = OWNER.context;
        if (register) {
            const suspense = this.get(SYMBOL_SUSPENSE);
            if (suspense) {
                this.registered = true;
                lazySetAdd(this.parent, 'roots', this);
            }
        }
    }
    /* API */
    dispose(deep) {
        if (this.registered) {
            lazySetDelete(this.parent, 'roots', this);
        }
        super.dispose(deep);
    }
    wrap(fn, owner, observer, stack) {
        const dispose = (disposeStack) => this.dispose(true);
        // Create a wrapper that accepts the stack parameter from Owner.wrap and passes both stack and dispose to the original function
        const wrapper = (callStack) => fn(callStack, dispose);
        return super.wrap(wrapper, this, undefined, stack);
    }
}
/* EXPORT */
export default Root;
